import { Flex, FlexProps, Image, Progress, Text } from 'components'
import { useContext, useEffect, useState } from 'react'
import { LoadingContext, SessionContext } from './providers'

interface Props extends FlexProps {}

export default function FileLoader(props: Props) {
  const { status, error, assetProgress } = useContext(LoadingContext)

  if (error)
    return (
      <Flex {...props}>
        <Text color="danger.500">{error}</Text>
      </Flex>
    )

  return (
    <Flex flexDirection="column" gap={1} {...props}>
      {status.includes('getting') && (
        <Progress
          borderRadius={2}
          size="xs"
          isIndeterminate={assetProgress === -1}
          value={assetProgress * 100}
        />
      )}

      <Text whiteSpace="nowrap">
        {status === 'getting-documents'
          ? 'Updating configuration...'
          : status === 'getting-assets'
          ? 'Downloading files...'
          : ''}
        &nbsp;
      </Text>
    </Flex>
  )
}

export function FileLoaderToast() {
  const { status } = useContext(LoadingContext)
  const { status: sessionStatus } = useContext(SessionContext)
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (sessionStatus === 'init' || status === 'done') setShow(false)
    if (sessionStatus !== 'init' && status !== 'done') setShow(true)
  }, [status, sessionStatus])

  if (!show) return null

  return (
    <Flex
      position="absolute"
      bottom="8px"
      left="50%"
      transform="auto"
      translateX="-50%"
      zIndex={100}
      background="secondary.700"
      p={4}
      borderRadius="sm"
      gap={6}
      alignItems="center"
    >
      <Image src="/common/momentify-icon-light.svg" h="20px" />

      <FileLoader width="200px" />
    </Flex>
  )
}
